module.exports = __webpack_public_path__ + "static/media/right.129c7fc6.svg";